import { JsonItem, PickListItem } from "../web-form/web-form.objects";
import { getDisplayDate } from "../../scripts/date-functions";

export class TableRenderer {
    pickLists: JsonItem[];
    constructor(pickLists: JsonItem[]) {
        this.pickLists = pickLists;
    }

    renderDisplay(data: any, renderType: TableRenderType, pickListId: string = "", separator: string = ", "): string {
        let foundList: PickListItem[] = this.pickLists.find(list => list.Id == pickListId)?.Json;
        if (!foundList) {
            return "";
        }

        let returnVal = "";
        switch (renderType) {
            case TableRenderType.Number:
                let targetId = (<number>data)?.toString();
                let foundItem = foundList.find(item => item.Id.toString() == targetId)
                if (foundItem) returnVal = foundItem.Value;
                break;
            case TableRenderType.PipePathSeparatedIds:
                let targetIds = (<string>data)?.toString();
                if (!targetIds) {
                    break;
                }
                let valArr: string[] = [];
                let idArr = targetIds.split("|");
                idArr.forEach(id => {
                    let foundItem = foundList.find(item => item.Id.toString() == id);
                    if (foundItem) valArr.push(foundItem.Value);
                });
                valArr.sort();
                returnVal = valArr.join(separator);
                break;
            case TableRenderType.PipePathSeparatedBullets:
                let targetBulletIds = (<string>data)?.toString();
                if (!targetBulletIds) {
                    break;
                }
                let bulletArr: string[] = [];
                let bulletIdArr = targetBulletIds.split("|");
                bulletIdArr.forEach(id => {
                    let foundItem = foundList.find(item => item.Id.toString() == id);
                    if (foundItem) bulletArr.push(foundItem.Value);
                });
                bulletArr.sort();

                let bulletHtml = "";
                bulletArr.forEach(item => {
                    bulletHtml += `<li class="pb-2">${item}</li>`
                });
                returnVal = `
                    <ul class="pl-3 mb-0">
                        ${bulletHtml}
                    </ul>
                `;
                break;
        }

        return returnVal;
    }

    renderDate(data: any): string {
        return getDisplayDate(data);
    }

    renderLink(data: any): string {
        let url = <string>data;
        if (!url) {
            return "";
        }

        let link = `
            <a href="${url.trim()}" target="_blank">
                ${url.trim()}<i class="fa-solid fa-arrow-up-right-from-square ml-1"></i>
            </a>
        `;

        return link;
    }

    renderYesNo(data: any): string {
        let returnVal = "<div class='edit-table-inactive-block'>No</div>";
        if (data) {
            returnVal = "<div class='edit-table-active-block'>Yes</div>"
        }
        return returnVal;
    }

    renderLargeText(data: any, trimCount: number = 500): string {
        let text = <string>data;
        if (!text) {
            return "";
        }
        
        let trimText = text;
        if (text.length > trimCount) {
            trimText = text.substring(0, trimCount);
            trimText += "...";
        }
        return trimText;
    }
}

export enum TableRenderType {
    String = 1,
    Number = 2,
    PipePathSeparatedIds = 3,
    PipePathSeparatedStrings = 4,
    YesNo = 5,
    Date = 6,
    PipePathSeparatedBullets = 7,
}

export class RenderGroup {
    propertyName: string; // PropertyName
    renderType: TableRenderType; // How to Display
    pickListId: string; // optionally add pickListId

    constructor(propName: string, renderType: TableRenderType, pickListId: string = "") {
        this.propertyName = propName;
        this.renderType = renderType;
        this.pickListId = pickListId;
    }
}